import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VueReCaptcha } from "vue-recaptcha-v3";

// Google reCAPTCHA site key for digiprod.com.br
const RECAPTCHA_SITE_KEY = "6Ldu1f4rAAAAAKdC2oAlvwBE7ER5srO_a8mMXcR8";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueReCaptcha, {
  siteKey: RECAPTCHA_SITE_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
  },
});

app.mount("#app");
